// extracted by mini-css-extract-plugin
module.exports = {"progress":"styles_progress__1kKsC","step":"styles_step__sy2K7","completed":"styles_completed__3qq51","current":"styles_current__3Utm6","future":"styles_future__2wpdr"};